import { LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupList" */ './lazyIndex');
});
// Delay loaded actions
export var lazyLoadGroups = new LazyAction(lazyModule, function (m) { return m.loadGroups; });
export var lazyLoadGroupsFromSessionData = new LazyAction(lazyModule, function (m) { return m.loadGroupsFromSessionData; });
export var lazyLoadUnifiedGroupsSettings = new LazyAction(lazyModule, function (m) { return m.loadUnifiedGroupsSettingsAction; });
export var lazyRemoveGroupFromLeftNav = new LazyAction(lazyModule, function (m) { return m.removeGroupFromLeftNav; });
export var lazyToggleGroupTreeExpansion = new LazyAction(lazyModule, function (m) { return m.toggleGroupTreeExpansion; });
export var lazyUnsubscribeFromUnreadNotifications = new LazyAction(lazyModule, function (m) { return m.unsubscribeFromUnreadNotifications; });
export var lazySetGroupLastVisitedTime = new LazyAction(lazyModule, function (m) { return m.setGroupLastVisitedTime; });
//# sourceMappingURL=index.js.map